import { api } from 'platformsh-client'

export const request = api
